export const convertFiasAddressItemToAddressItem = (item) => {
    if (!item) {
        return;
    }
    const data = item.data;
    return {
        name: item.name || item.text,
        fiasId: data?.fiasId || undefined,
        abbreviation: data?.abbreviation || undefined,
        kladrCode: data?.code,
    };
};
